import React from 'react';
import StatusIcon from 'view/components/common/StatusIcon';
import { formatDate } from 'utils/utils';
import ItemPanel from 'view/components/common/ItemPanel';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Evaluation from 'models/Evaluation';
import EvaluationSubmission from 'models/EvaluationSubmission';

interface EvaluationSubmissionRowProps {
  label: string;
  evaluationSubmission: EvaluationSubmission;
  evaluation: Evaluation;
  selected: boolean;
  setSelected: (evaluationSubmission: string) => void;
  onUpdateEvaluationSubmission: (
    evaluationSubmission: EvaluationSubmission,
    field: string,
    value: any,
  ) => void;
}

const EvaluationSubmissionRow: React.FC<EvaluationSubmissionRowProps> = ({
  label,
  evaluationSubmission,
  evaluation,
  selected,
  setSelected,
  onUpdateEvaluationSubmission,
}) => {
  // const [editEvaluation, setEditEvaluation] = useState<EvaluationSubmission>();

  // const handleClickSubmission = (clickedSubmission: EvaluationSubmission) => {
  //   if (clickedSubmission === editEvaluation) {
  //     // if (newGrade !== clickedAssignmentSubmission.grade) {
  //     //   onUpdateAssignmentSubmission(
  //     //     clickedAssignmentSubmission,
  //     //     'grade',
  //     //     newGrade,
  //     //   );
  //     // }
  //     setEditEvaluation(undefined);
  //   } else {
  //     // setNewGrade(clickedSubmission.grade);
  //     setEditEvaluation(clickedSubmission);
  //   }
  // };

  return (
    <ItemPanel
      id={`student-evaluation-${evaluationSubmission.id}`}
      expanded={selected}
      onClick={() => setSelected(evaluationSubmission.id)}
      onDoubleClick={() => setSelected(evaluationSubmission.id)}
    >
      <div className="row spaced" style={{ width: '100%' }}>
        <div className="row">
          <label className="label-normal">{label}</label>
          {evaluationSubmission.date_completed && (
            <div className="row">
              <StatusIcon
                icon={faCheckCircle}
                color="var(--dark-green)"
                text={`Submitted ${formatDate(
                  new Date(evaluationSubmission.date_completed),
                )}`}
              />
            </div>
          )}
          {/* <StatusIcon
            icon={faEye}
            color="var(--dark-green)"
            text="View"
            onClick={handleViewSubmission}
          /> */}
        </div>
      </div>
      {selected && (
        <div className="col">
          <span className="label-xs">
            Listening: {evaluationSubmission.wida_listening}/6.0
          </span>
          <span className="label-xs">
            Reading: {evaluationSubmission.wida_reading}/6.0
          </span>
          <span className="label-xs">
            Speaking: {evaluationSubmission.wida_speaking}/6.0
          </span>
          <span className="label-xs">
            Writing: {evaluationSubmission.wida_writing}/6.0
          </span>
        </div>
      )}
    </ItemPanel>
  );
};

export default EvaluationSubmissionRow;
